<template>
    <div v-if="product" @click="chooseProduct(product)" :class="[{'product-upsell--disabled': isProductDisabled},productUpsellClass(product),productUpsellCardType, {'position-relative': productUpsellCardType !== 'product-upsell'}]">
        <div
            :class="[
                'inner d-flex flex-column justify-content-between',
                { 'product-upsell--highlighted': product.type === 'PMP'},
                { 'selected': chosenProductToDisplay }
            ]
            "
        >
            <div class="product-upsell-main position-relative">
                <h5 class="title text-center mb-4 mt-3"><img :src="icons[product.type]" alt=""></h5>

                <h4 class="title upsell-title text-capitalize">{{ title }}</h4>
                <product-details-simplified
                  :showTermsAndConditions="showTermsAndConditions"
                  :product="product"
                  :upsell-card-type="productUpsellCardType"
                  :class="{'product-details--highlighted': product.type === 'PMP' && !usBookingMobile }"
                ></product-details-simplified>
            </div>
            <div v-if="!usBookingMobile" class="product-upsell__footer">
                <span class="product-upsell__range">
                    <img :src="icon" alt=""/>
                    {{ labels.quoteHireLength }}
                </span>
                <div class="product-upsell__selection">
                    <div v-if="product.total_price >= selectedProduct.total_price"  class="total">
                        <strong v-if="showOriginalUpsellPrice(product)" class="original-amount-free-upgrade">
                            {{ freeProductUpgradeOriginalDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}
                        </strong>
                        &plus;&nbsp;{{ freeProductUpgradeDisplayPrice(selectedProduct, product) }} <small>{{ labels.extraPerDay }}</small>
                    </div>
                    <div v-else  class="total">
                        <strong v-if="showOriginalUpsellPrice(product)" class="original-amount-free-upgrade">
                            {{ freeProductUpgradeOriginalDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}
                        </strong>
                        &minus;&nbsp;{{ freeProductUpgradeDisplayPrice(selectedProduct, product) }} <small>{{ labels.extraPerDay }}</small>
                    </div>
                    <span v-if="!isProductDisabled"  class="checkRound">
                        <img svg-inline :src="checkmark">
                    </span>
                </div>
            </div>

            <div
                v-else
                 class="product-upsell-footer"
            >
                <template>
                  <button
                    v-if="upsellCardType !== 'edit-booking' || this.upsellCardType === 'edit-booking' && !chosenProductToDisplay"
                    :class="['btn mb-2',{'editing': upsellCardType === 'edit-booking'},{'btn-link-outline': product.type !== 'PMP'},{'btn-solid': product.type === 'PMP'},'w-100 py-4']"
                    :disabled="(isProductDisabled && upsellCardType === 'edit-booking') || (upsellCardType === 'edit-booking' && product.type === selectedProduct.type)"
                    data-dismiss="modal"
                  >
                    {{ $t('VehicleCard.upgrade') }}
                  </button>
                  <button
                    v-if="this.upsellCardType === 'edit-booking' && chosenProductToDisplay"
                    :class="['btn mb-2',{'editing': upsellCardType === 'edit-booking'},{'btn-link-outline': product.type !== 'PMP'},{'btn-solid': product.type === 'PMP'},'w-100 py-4']"
                    :disabled="upsellCardType === 'edit-booking'"
                    data-dismiss="modal"
                  >
                    {{ $t('PriceCard.current_choice') }}
                  </button>

                    <div class="total text-center" v-if="loadingPrices">
                        <strong>&hellip;</strong>
                    </div>
                    <div v-else>
                        <div v-if="product.should_show_difference"  class="total text-center">
                            <div v-if="showOriginalUpsellPrice(product)">
                                <b class="original-amount-free-upgrade">{{ freeProductUpgradeOriginalDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}</b>

                                <span v-if="product.difference >= 0">&plus;</span>
                                <span v-else>&minus;</span>
                                &nbsp;<strong v-if="showOriginalUpsellPrice(product)">
                                    {{ freeProductUpgradeCurrentDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}
                                </strong>
                                <small>{{ labels.extraPerDay }}</small>
                            </div>
                            <div v-else>
                                <span v-if="product.difference >= 0">&plus;</span>
                                <span v-else>&minus;</span>
                                &nbsp;<b>{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }}</b> <small>{{ labels.extraPerDay }}</small>
                            </div>
                        </div>
                        <div v-else-if="product.total_price >= selectedProduct.total_price" class="total text-center">
                            <strong v-if="showOriginalUpsellPrice(product)" class="original-amount-free-upgrade">
                                {{ freeProductUpgradeOriginalDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}
                            </strong>
                            &plus;&nbsp;<b>{{ freeProductUpgradeDisplayPrice(selectedProduct, product) }}</b> <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <div v-else  class="total text-center">
                            <strong v-if="showOriginalUpsellPrice(product)" class="original-amount-free-upgrade">
                                {{ freeProductUpgradeOriginalDiffPerDay(selectedProduct, product, this.quoteHireDuration) }}
                            </strong>
                            &minus;&nbsp;<b>{{ freeProductUpgradeDisplayPrice(selectedProduct, product) }}</b> <small>{{ labels.extraPerDay }}</small>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductDetailsSimplified from './ProductDetailsSimplified';
import Accounting from '../../mixins/accounting';
import { setUpdateBooking } from '../../vuex/quotes/actions';
import { getModification } from '../../vuex/quotes/getters';
import VehicleCardLocalisations from '../../lang/VehicleCard';
import PriceCard from '../../lang/PriceCard';
import branding from '../../mixins/branding';

export default {
    props: [
        'product',
        'title',
        'icon',
        'isDisabled',
        'labels',
        'showTermsAndConditions',
        'upsellCardType',
        'upgradeService',
        'setEditing',
        'upsellModalVisible',
        'basicProductId',
        'setType',
        'useFreeProductUpgrade',
    ],
    mixins: [Accounting, branding],

    i18n: VehicleCardLocalisations,

    components: {
        ProductDetailsSimplified,
    },
    data() {
        return {
            authenticated: window.greenmotion.authenticated || false,
            checked: this.requireCheckedIcon(),
            unchecked: this.requireUncheckedIcon(),
            icons: {
                PLU: this.brandingImagesPath('/images/vehicle-listing/plus-badge.svg'),
                PRE: this.brandingImagesPath('/images/vehicle-listing/premium-badge.svg'),
                PMP: this.brandingImagesPath('/images/vehicle-listing/premium-plus-badge.svg'),
            },
            loadingPrices: false,
            disableTemporarily: false,
            handlePricesLoading: null,
            handleTemporarilyDisableProducts: null,
            handleEnableProducts: null,
        };
    },
    computed: {
        ...mapGetters({
            quote: 'getQuote',
            selectedCurrency: 'selectedCurrency',
            selectedVehicle: 'getSelectedVehicle',
            selectProduct: 'getSelectedVehicleProduct',
            quoteHireDuration: 'quoteHireDuration',
            extras: 'getExtras',
            selectedExtras: 'getSelectedExtras',
            editing: 'getBookingUpdateStatus',
            booking: 'getBooking',
            modification: 'getModification',
        }),
        isRouteTypeGuest() {
            return this.$router?.currentRoute?.meta?.userType === 'guest';
        },
        chosenProductToDisplay() {
            return (
                ((this.modification?.rental_code === '' || this.modification?.errors || typeof this.modification?.rental_code === 'undefined') && this.selectedProduct.type === this.product.type) ||
                (this.modification?.rental_code !== '' && this.modification?.rental_code === this.product.type)
            );
        },
        isUSSource() {
            if (this.selectedVehicle?.charges || this.quote?.us_location) {
                return true;
            }
            return false;
        },
        isProductDisabled() {
            return this.isDisabled || this.disableTemporarily;
        },
        selectedProduct() {
            return this.selectProduct;
        },
        checkmark() {
            if (this.selectedProduct.id === this.product.id) {
                return this.checked;
            }

            return this.unchecked;
        },
        productUpsellCardType() {
            if (this.usBookingMobile) {
                if (this.modification?.rental_code === '' && this.selectedProduct.id === this.product.id) {
                    return 'us-product-selected';
                }
                return 'us-product-upsell';
            }
            return 'product-upsell';
        },
        usBookingMobile() {
            return !!(this.upsellCardType && (this.upsellCardType === 'us-source-booking' || this.upsellCardType === 'edit-booking'));
        },
        freeProductUpgradeTargetType() {
            return this.quote?.free_product_upgrade_target_type || null;
        },
    },
    methods: {
        showOriginalUpsellPrice(product) {
            return this.isFreeProductUpgradeSelected() && this.hasFreeProductUpgradeOriginalDiff(product);
        },
        isFreeProductUpgradeSelected() {
            if (this.booking.is_free_product_upgrade_applied) {
                return false;
            }

            if (typeof this.useFreeProductUpgrade !== 'undefined') {
                return !!this.useFreeProductUpgrade;
            }

            return !!this.quote?.use_free_product_upgrade;
        },
        hasFreeProductUpgradeOriginalDiff(product) {
            return typeof product.free_product_upgrade_original_difference_without_conversion !== 'undefined' || typeof product.free_product_upgrade_original_difference !== 'undefined';
        },
        freeProductUpgradeDisplayPrice(selectedProduct, product) {
            if (
                this.isFreeProductUpgradeSelected() &&
                (typeof product.free_product_upgrade_current_difference_without_conversion !== 'undefined' || typeof product.free_product_upgrade_current_difference !== 'undefined')
            ) {
                return this.freeProductUpgradeCurrentDiffPerDay(selectedProduct, product, this.quoteHireDuration);
            }

            return this.selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration);
        },
        productUpsellClass(product) {
            return `product-upsell--${product.type}`;
        },
        isRestrictedByFreeProductUpgrade(product) {
            if (!this.isFreeProductUpgradeSelected() || !this.freeProductUpgradeTargetType) {
                return false;
            }

            return product.type !== this.freeProductUpgradeTargetType;
        },
        canChooseProduct(product) {
            return !this.isProductDisabled && !this.isRestrictedByFreeProductUpgrade(product);
        },

        /*
        |--------------------------------------------------------------------------
        | Booking mods: Step 3a - Choose Product
        |--------------------------------------------------------------------------
        | When a user is modifying a booking and selects a new product,
        | we send a request to the API, which will also send a simulation request (SIM)
        | to FMX to get the new pricing for the selected product.
        */
        async chooseProduct(product) {
            if (!this.canChooseProduct(product)) {
                return;
            }

            if (product.type === this.selectedProduct.type || product.type === this.modification?.rental_code) {
                return;
            }

            window.bus.$emit('prices-are-loading', true);
            window.bus.$emit('temporarilyDisableProducts', product.id);
            window.bus.$emit('temporarilyDisableExtras');

            try {
                const quoteId = this.quote.id;
                const originalId = this.booking ? this.booking.quote_id : null;

                let productId = this.selectedProduct.type === product.type && this.upsellCardType === 'edit-booking' ? this.basicProductId : product.id;

                if (typeof this.setType !== 'undefined') {
                    this.setType(product.type);
                }

                const isPartialModification = typeof this.quote.id !== 'undefined' && typeof this.booking !== 'undefined' && this.quote.id === this.booking.quote_id;
                const isBeingModified = typeof this.modification !== 'undefined' && this.booking?.can_be_modified;
                const isFullModification = typeof this.modification !== 'undefined' && this.booking?.can_be_modified && this.quote.id !== this.booking.quote_id;

                // If it's a partial modification (only selected a new product), then we just update the vehicle with booking.
                // This will create a new booking update quote or select the existing one for the same booking, and then
                // update the details with the new product and prices.
                if (typeof this.$route !== 'undefined' && this.$route.params.booking && isPartialModification) {
                    if (product.type === this.modification?.rental_code || this.selectedProduct?.type === product.type) {
                        productId = this.selectedProduct.id;
                    }

                    await this.$store.dispatch('updateVehicleWithBooking', {
                        selectedVehicle: this.selectedVehicle,
                        productId: productId,
                        bookingId: this.booking.id,
                        bookingReference: this.booking.reference,
                        quoteId: quoteId,
                        useFreeProductUpgrade: this.isFreeProductUpgradeSelected(),
                    });

                    // Refresh the quote once the backend finishes updating the booking. This is to get the updated prices for the products.
                    await this.$store.dispatch('fetchQuote', quoteId);
                } else if (isBeingModified && isFullModification) {
                    // If it's a full modification (selected a new product and vehicle), then we also need to update the selected vehicle.
                    if (product.type === this.modification?.rental_code || this.selectedProduct?.type === product.type) {
                        productId = this.selectedProduct.id;
                    }

                    try {
                        // Updating the vehicle will ensure that we keep the selected extras on the modification quote.
                        await this.$store.dispatch('updateVehicle', {
                            selectedVehicle: this.selectedVehicle,
                            productId: productId,
                            quoteId: quoteId,
                        });

                        await this.$store.dispatch('updateVehicleWithBooking', {
                            selectedVehicle: this.selectedVehicle,
                            productId: productId,
                            bookingId: this.booking.id,
                            bookingReference: this.booking.reference,
                            quoteId: quoteId,
                            useFreeProductUpgrade: this.isFreeProductUpgradeSelected(),
                        });

                        if (originalId !== null) {
                            await this.$store.dispatch('fetchTotals', quoteId);
                        }
                    } catch (error) {
                        this.$store.dispatch('createError', error);
                    }
                } else {
                    await this.$store
                        .dispatch('updateVehicle', {
                            selectedVehicle: this.selectedVehicle,
                            productId: productId,
                            quoteId: quoteId,
                        })
                        .then((response) => {
                            if (originalId !== null) {
                                this.$store.dispatch('copyUpdateExtras', {
                                    quoteId,
                                    originalId,
                                });

                                this.$store.dispatch('fetchTotals', quoteId).then((response) => {});

                                if (product.type !== 'BAS' || this.isUSSource) {
                                    this.$store.dispatch('setUpdateBooking', true);
                                } else {
                                    this.$store.dispatch('setUpdateBooking', false);
                                }
                            }
                        })
                        .catch((error) => {
                            this.$store.dispatch('createError', error);
                        });
                }
            } finally {
                window.bus.$emit('prices-are-loading', false);
                window.bus.$emit('enableExtras');
                window.bus.$emit('enableProducts');
            }
        },
    },
    mounted() {
        if (this.$route.params.booking) {
            const bookingId = this.$route.params.booking;

            this.$store.dispatch('fetchBooking', bookingId).catch((error) => console.log(error));
        }

        this.handlePricesLoading = (status) => {
            this.loadingPrices = status;
        };

        this.handleTemporarilyDisableProducts = (productId = null) => {
            // Disable the product if another one is being modified
            if (this.product.id !== productId) {
                this.disableTemporarily = true;
            }
        };

        this.handleEnableProducts = () => {
            // Enable the product if the modification is done
            this.disableTemporarily = false;
        };

        window.bus.$on('prices-are-loading', this.handlePricesLoading);
        window.bus.$on('temporarilyDisableProducts', this.handleTemporarilyDisableProducts);
        window.bus.$on('enableProducts', this.handleEnableProducts);
    },
    beforeDestroy() {
        window.bus.$off('prices-are-loading', this.handlePricesLoading);
        window.bus.$off('temporarilyDisableProducts', this.handleTemporarilyDisableProducts);
        window.bus.$off('enableProducts', this.handleEnableProducts);
    },
};
</script>

<style lang="scss" src="./scss/product-upsell.scss"></style>
